var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import * as React from 'react';
import { Link } from 'react-router-dom';
import { PORTAL_ROUTE_PREFIX } from '../../constants/values';
import styled from 'styled-components';
import ListCell from '@doordash/component-list-cell';
import AdminPageEmptyState from '../admin_page_empty_state';
import { Icon, BorderRadius, Colors, InlineChildren, Text, Stack, } from '@doordash/design-language';
import Popover from '@doordash/component-popover';
import { IconButton } from '@doordash/component-button';
var ListCellContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border: 1px solid ", ";\n  border-radius: ", "px;\n"], ["\n  border: 1px solid ", ";\n  border-radius: ", "px;\n"])), Colors.SystemGrey10, BorderRadius.Small);
var PopoverContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  min-width: 200px;\n  border-radius: ", "px;\n"], ["\n  min-width: 200px;\n  border-radius: ", "px;\n"])), BorderRadius.Medium);
export var ActionMenu = function (_a) {
    var group = _a.group, onDeleteGroupClick = _a.onDeleteGroupClick, onEditGroupClick = _a.onEditGroupClick, onAddMembersClick = _a.onAddMembersClick;
    var _b = __read(React.useState(false), 2), isPopoverVisible = _b[0], setIsPopoverVisible = _b[1];
    var dismissPopover = function () { return setIsPopoverVisible(false); };
    var menuOptions = [
        {
            key: 'add-members',
            title: 'Add Members',
            onActionClick: function (e) {
                e.stopPropagation();
                // TODO add members handling
                setIsPopoverVisible(false);
                onAddMembersClick(group);
            },
        },
        {
            key: 'edit-group',
            title: 'Edit group',
            onActionClick: function (e) {
                e.stopPropagation();
                setIsPopoverVisible(false);
                onEditGroupClick(group);
            },
        },
        {
            key: 'delete-group',
            title: 'Delete group',
            onActionClick: function (e) {
                e.stopPropagation();
                setIsPopoverVisible(false);
                onDeleteGroupClick(group);
            },
        },
    ];
    React.useEffect(function () {
        document.addEventListener('click', dismissPopover);
        return function () {
            document.removeEventListener('click', dismissPopover);
        };
    });
    return (React.createElement(Popover, { position: Popover.Positions.BottomRight, interactionType: Popover.InteractionTypes.Controlled, showContainerPointer: false, isVisible: isPopoverVisible, content: React.createElement(PopoverContainer, null, menuOptions.map(function (option) { return (React.createElement(ListCell, { isSeparatorVisible: true, key: option.key, title: option.title, titleOverrides: { size: Text.Sizes.S16 }, onClick: option.onActionClick })); })) }, function (_a) {
        var describedBy = _a.describedBy;
        return (React.createElement(IconButton, { accessibilityLabel: "Actions", accessibilityDescribedBy: describedBy, iconType: IconButton.IconTypes.MoreHorizontal, onClick: function (e) {
                e.stopPropagation();
                e.preventDefault();
                setIsPopoverVisible(!isPopoverVisible);
            } }));
    }));
};
export var GroupsList = function (_a) {
    var teamAccountId = _a.teamAccountId, groups = _a.groups, onDeleteGroupClick = _a.onDeleteGroupClick, onEditGroupClick = _a.onEditGroupClick, onAddMembersClick = _a.onAddMembersClick;
    if (groups.length === 0) {
        return (React.createElement(AdminPageEmptyState, { icon: React.createElement(Icon, { type: Icon.Types.PersonFindFill, size: Icon.Sizes.Large }), title: "No Groups", subtitle: "Start by creating a group" }));
    }
    return (React.createElement(React.Fragment, null, groups.map(function (group) { return (React.createElement(Stack, { key: group.id, size: Stack.Sizes.Large },
        React.createElement(Link, { to: PORTAL_ROUTE_PREFIX + "/admin/" + teamAccountId + "/groups/" + group.id },
            React.createElement(ListCellContainer, null,
                React.createElement(ListCell, { key: group.id, title: group.name, titleOverrides: { size: Text.Sizes.S16 }, subtext: group.description || '- -', subtextOverrides: { color: Text.Colors.TextSecondary }, isSeparatorVisible: false, secondaryTitleAlignment: InlineChildren.Alignment.Center, secondaryTitleOverrides: {
                        size: Text.Sizes.S14,
                        color: Text.Colors.TextSecondary,
                    }, renderAfterContent: function () { return (React.createElement(ActionMenu, { group: group, onDeleteGroupClick: onDeleteGroupClick, onEditGroupClick: onEditGroupClick, onAddMembersClick: onAddMembersClick })); } }))))); })));
};
export default GroupsList;
var templateObject_1, templateObject_2;
